interface Location {
  formatted_address: string
  geometry: { location: { lat: () => void; lng: () => void } }
  address_components: any
}

export const getProvince = (location: Location) => {
  if (location && location.address_components) {
    const provinceComponent = location.address_components.find(addressComponent => {
      return (
        addressComponent.types.includes('administrative_area_level_2') && addressComponent.types.includes('political')
      )
    })

    if (provinceComponent) {
      return provinceComponent.long_name
    }

    return 'provincia'
  }

  return 'provincia'
}



// WEBPACK FOOTER //
// ./src/utils/locationFormatter.ts